import { useTranslation } from 'react-i18next'
import { Icon } from '@bosch/react-frok'

import './HorizontalPager.scss'

interface HorizontalPagerProps {
    page: number
    pageCount: number
    onPageChange: (page: number) => void
}

// Buttons and page indicator of a horizontal row: previous, one dot per page, next
const HorizontalPager = ({ page, pageCount, onPageChange }: HorizontalPagerProps) => {
    const { t } = useTranslation()

    return (
        <nav className="horizontal-pager" aria-label={t('chat:groupPager.label')}>
            <button
                type="button"
                className="horizontal-pager__arrow --prev"
                disabled={page === 0}
                onClick={() => onPageChange(page - 1)}
                aria-label={t('chat:groupPager.previous')}
            >
                <Icon iconName="forward-right-small" />
            </button>
            {Array.from({ length: pageCount }, (_, i) => (
                <button
                    key={i}
                    type="button"
                    className={`horizontal-pager__dot${i === page ? ' --active' : ''}`}
                    onClick={() => onPageChange(i)}
                    aria-label={t('chat:groupPager.page', { n: i + 1 })}
                    aria-current={i === page ? 'true' : undefined}
                />
            ))}
            <button
                type="button"
                className="horizontal-pager__arrow --next"
                disabled={page === pageCount - 1}
                onClick={() => onPageChange(page + 1)}
                aria-label={t('chat:groupPager.next')}
            >
                <Icon iconName="forward-right-small" />
            </button>
        </nav>
    )
}

export default HorizontalPager
